import { Alert } from '@piggytechng/component-library';
import { isValidEmail, isValidPhoneNumber, isValidName } from '.';

export function validateLogin(values) {
  let errors = {};

  if (!values.email.trim()) {
    errors.email = 'Email is required';
  } else if (!isValidEmail(values.email)) {
    errors.email = 'Email is invalid';
  }

  if (!values.password) {
    errors.password = 'Password is required';
  }

  return errors;
}

export function validateSignup(values) {
  let errors = {};

  if (!values.first_name.trim()) {
    errors.first_name = 'First Name is required';
  }
  if (!values.last_name.trim()) {
    errors.last_name = 'Last Name is required';
  }
  if (!values.business_name.trim()) {
    errors.business_name = 'Business Name is required';
  }
  if (!values.email.trim()) {
    errors.email = 'Email is required';
  }
  if (!values.rc_number.trim()) {
    errors.rc_number = 'RC Number is required';
  }
  if (!values.phone.trim()) {
    errors.phone = 'Phone Number is required';
  }
  if (!values.password) {
    errors.password = 'Password is required';
  }

  return errors;
}

export function validateForgotPassword(values) {
  let errors = {};

  if (!values.email.trim()) {
    errors.email = 'Email is required';
  } else if (!isValidEmail(values.email)) {
    errors.email = 'Email is invalid';
  }

  return errors;
}

export function validateCompleteForgotPassword(values) {
  let errors = {};

  if (!values.password.trim()) {
    errors.password = 'Password is required';
  }

  if (!values.confirmPassword.trim()) {
    errors.confirmPassword = 'Confirm password is required';
  }

  if (
    values.password.trim() !== values.confirmPassword.trim() &&
    values.password.trim() &&
    values.confirmPassword.trim()
  ) {
    errors.confirmPassword = 'Passwords do not match';
  }

  return errors;
}

export function validateRequestPaypoint(values) {
  let errors = {};

  if (!values.name.trim()) {
    errors.name = 'Paypoint name is required';
  } else if (!isValidName(values.name)) {
    errors.name = 'Paypoint name is invalid';
  }

  if (!values.tag.trim()) {
    errors.tag = 'Tag is required';
  }

  if (!values.delivery_phone_number.trim()) {
    errors.delivery_phone_number = 'Phone number is required';
  } else if (!isValidPhoneNumber(values.delivery_phone_number)) {
    errors.delivery_phone_number = 'Phone number is invalid';
  }

  if (!values.settlement_subaccount_id.trim()) {
    errors.settlement_subaccount_id = 'Settlement subaccount is required';
  }

  if (!values.withdrawal_subaccount_id.trim()) {
    errors.withdrawal_subaccount_id = 'Withdrawal subaccount is required';
  }

  if (!values.delivery_name.trim()) {
    errors.delivery_name = 'Full name is required';
  } else if (!isValidName(values.delivery_name)) {
    errors.delivery_name = 'Full name is invalid';
  }

  if (!values.delivery_address.trim()) {
    errors.delivery_address = 'Delivery address is required';
  }

  if (!values.delivery_state.trim()) {
    errors.delivery_state = 'Delivery state is required';
  }

  if (!values.delivery_city.trim()) {
    errors.delivery_city = 'Delivery city is required';
  }

  return errors;
}

export function validateUpdatePaypoint(values) {
  let errors = {};

  if (values.name !== undefined && !values.name.trim()) {
    errors.name = 'Paypoint name is required';
  }

  if (values.phone !== undefined && !values.phone.trim()) {
    errors.phone = 'Phone is required';
  }

  if (values.email !== undefined && !values.email.trim()) {
    errors.email = 'Email is required';
  } else if (values.email !== undefined && !isValidEmail(values.email)) {
    errors.email = 'Email is invalid';
  }

  if (values.address !== undefined && !values.address.trim()) {
    errors.address = 'Address is required';
  }

  if (values.subaccount_id !== undefined && !values.subaccount_id.trim()) {
    errors.subaccount_id = 'Subaccount is required';
  }

  if (values.password !== undefined && !values.password.trim()) {
    errors.password = 'Password is required';
  }

  return errors;
}

export function validateDataSearchForm(values, which, toast = true) {
  let errors = [];

  if (which === 'users') {
    if (!values.query.trim()) {
      errors.push({ field: 'query', message: 'Search value is required' });
    }

    if (!values.activeFilter.trim()) {
      errors.push({ field: 'activeFilter', message: 'Search criteria is required' });
    }
  }

  if (which === 'usdrequests') {
    if (!values.search.trim()) {
      errors.push({ field: 'search', message: 'Search value is required' });
    }
  }

  if (which === 'withdrawalManager') {
    if (!values.query.trim()) {
      errors.push({ field: 'query', message: 'Search value is required' });
    }

    if (!values.queryFilter.trim()) {
      errors.push({ field: 'queryFilter', message: 'Search criteria is required' });
    }
  }

  if (which === 'admins') {
    if (!values.value.trim()) {
      errors.push({ field: 'value', message: 'Search value is required' });
    }

    if (!values.filter.trim()) {
      errors.push({ field: 'filter', message: 'Search criteria is required' });
    }
  }

  if (toast && errors.length) {
    errors.forEach((error) => {
      Alert.error(error.message);
    });
  }

  if (errors.length) {
    return false;
  } else {
    return true;
  }
}
